import normalize, { userSchema } from 'schema';
import {
  GET_AUTH_PROVIDER_URL,
  GET_AUTH_PROVIDER_URL_SUCCESS,
  GET_AUTH_PROVIDER_URL_FAILURE,
  SEND_EXTERNAL_AUTH_TOKEN,
  SEND_EXTERNAL_AUTH_TOKEN_SUCCESS,
  GET_AUTH_PROVIDER_DETAILS,
} from 'actionTypes';

export function getAuthProviderDetails(providers) {
  return {
    type: GET_AUTH_PROVIDER_DETAILS,
    providers,
  };
}

export function getAuthProviderUrl(provider) {
  return {
    type: GET_AUTH_PROVIDER_URL,
    provider,
    endpointArgs: { provider },
  };
}

export function getAuthProviderUrlSuccess(provider, response) {
  return {
    type: GET_AUTH_PROVIDER_URL_SUCCESS,
    provider,
    providerURL: response.payload.url,
  };
}

export function getAuthProviderUrlFailure(provider) {
  return {
    type: GET_AUTH_PROVIDER_URL_FAILURE,
    provider,
  };
}

export function sendExternalAuthToken(provider, authType, url) {
  return {
    type: SEND_EXTERNAL_AUTH_TOKEN,
    provider,
    authType,
    endpointArgs: { authType, provider },
    payload: { callback_request_url: url },
  };
}

export function sendExternalAuthTokenSuccess(response) {
  return {
    type: SEND_EXTERNAL_AUTH_TOKEN_SUCCESS,
    normalizedData: normalize(response.payload, userSchema),
    token: response.payload.token,
  };
}

export const VALID_AUTH_TYPES = ['login', 'register'];



// WEBPACK FOOTER //
// ./src/actions/oauthActions.js